(function() {
    module.exports = {
	init: init,
	continueHandler: continueHandler,
	stop:stop,
    };

    nodes = []
    links = []
    
    var link,node, simulation;
    
    function init(mode) {
	nodes=[]
	links=[]
	mainView = $("#main-view-container")
	createInterimNodes()
	nodes = nodes.concat([
	    {id: 'main-corner1', fx: mainView.offset().left, fy: mainView.offset().top -50, type: 'frame-anchor'},
	    {id: 'mid-corner1-top', fx: (mainView.offset().left + mainView.width())/4, fy: mainView.offset().top -50, type: 'frame-anchor'},	    
	    {id: 'mid-corner2-top', fx: (mainView.offset().left + mainView.width())/2, fy: mainView.offset().top -50, type: 'frame-anchor'},
	    {id: 'mid-corner3-top', fx: (mainView.offset().left + mainView.width())*0.75, fy: mainView.offset().top -50, type: 'frame-anchor'},
	    {id: 'main-corner2', fx: mainView.offset().left, fy: mainView.offset().top + mainView.height() -50, type: 'frame-anchor'},
	    {id: 'main-corner3', fx: mainView.offset().left + mainView.width(), fy: mainView.offset().top -50, type: 'frame-anchor'},
	    {id: 'main-corner4', fx: mainView.offset().left + mainView.width(), fy: mainView.offset().top + mainView.height() -50, type: 'frame-anchor'},
	    {id: 'mid-corner1-btm', fx: (mainView.offset().left + mainView.width())/4, fy: mainView.offset().top + mainView.height() -50, type: 'frame-anchor'},
	    {id: 'mid-corner2-btm', fx: (mainView.offset().left + mainView.width())/2, fy: mainView.offset().top + mainView.height() -50, type: 'frame-anchor'},	    
	    {id: 'mid-corner3-btm', fx: (mainView.offset().left + mainView.width())*0.75, fy: mainView.offset().top + mainView.height() -50, type: 'frame-anchor'},	    

	]);

	
//	linkNodes()
//	addConnectors()
	
	
	
	var svg = d3.select("svg#background"),
	    width = $("#background").width(),
	    height = $("#background").height();
//	    width = +svg.attr("width"),
//	    height = +svg.attr("height");
//
//	var colorRange = ['#000000', '#333333', '#555555', '#777777', '#999999'];
//	var color = d3.scaleOrdinal().range(colorRange).domain([1, 2, 3, 4, 5]);

//	var color = d3.scaleOrdinal(d3.schemeCategory20b);
 //   var color = rgb(200, 57, 255);
	
	simulation = d3.forceSimulation()
	    .force("link", d3.forceLink().id(function(d) { return d.id; }))
	    .force("charge", d3.forceManyBody().strength(-30))
//	    .force("center", d3.forceCenter(width / 2, height / 2));

	var linkLayer = svg.append("g")
	    .attr("class", "links")
	
	link = linkLayer.selectAll("line")
	    .data(links)
	    .enter().append("line")
	    .attr('stroke', '#fff')
	    .attr('stroke-width', 1)
	    .attr('opacity', 0.4)

	var nodeLayer = svg.append("g")
	    .attr("class", "nodes")
	
	node = nodeLayer.selectAll("circle")
	    .data(nodes)
	    .enter().append("circle")
	    .attr("r", function(d) { return d.type == 'int' ? 65: 0})
        .attr("fill", "rgb(200, 57, 255)")
	    .attr('opacity', 0.65)

	simulation
	    .nodes(nodes)
	    .on("tick", ticked);
	
//	simulation.force("link")
//	    .links(links);
	
	if(mode == 'connect') {
	    addObjectAnchors()
	    i = 1;
	    linkNodes()
	    addConnectors()
	    timedUpdate()
	}
    }

    function ticked() {
 //       var color = d3.scaleOrdinal(d3.schemeCategory20b).domain([1,2,3,4])
        link
	    	.attr("x1", function(d) { return d.source.x; })
	    	.attr("y1", function(d) { return d.source.y; })
	    	.attr("x2", function(d) { return d.target.x; })
	    	.attr("y2", function(d) { return d.target.y; });
	
		node
	    	.attr("cx", function(d) { return d.x; })
	    	.attr("cy", function(d) { return d.y; })
//			.attr("fill", function(d) { return color(d.cx); });
    }
    
    function update() {
/*	node = node.data(nodes)
	node.exit().remove()
	node
	    .attr("r", function(d) { return d.type == 'int' ? 5: 0})
	    .attr("fill", "rgb(200, 57, 255)")
	    .attr('opacity', 0.65)
	
	node = node.enter().append("circle")
	    .attr("r", function(d) { return d.type == 'int' ? 5: 0})
	    .attr("fill", "rgb(200, 57, 255)")
	    .attr('opacity', 0.65)
	    .merge(nodes)
*/	
	link = link.data(links)
	link.exit().remove()
	link = link.enter().append("line")
	    .attr('stroke', '#fff')
	    .attr('stroke-width', 1)
	    .attr('opacity', 0.4)
	    .merge(link)

	simulation
	    .nodes(nodes)
	    .on("tick", ticked);
	
	simulation.force("link")
	    .links(links);

	simulation.alphaTarget(1).restart() 
    }

    function timedUpdate() {
	newLinks = links;
	links = [];
	//	newLinks.sort(function(a, b){return 0.5 - Math.random()}).forEach(function(el, i) {
	newLinks.reverse().forEach(function(el, i) {
	    setTimeout(function() {
		links.push(el)
		update()
	    }, i*20)
	});
    }
    
    function continueHandler() {
	$(".intro-content").fadeOut(500, function() {
	    $(".intro-person").animate({
		opacity:'0.75',
	    }, 500)
	})
	addObjectAnchors()
	i = 1;
	linkNodes()
	addConnectors()
	update()
	
    }
    
    function createInterimNodes() {
	n = 1
	xVal = ($("#background").width()/2)-50;
	yVal = ($("#background").height()/2)-50;
	while(n<150) {
	    nodes.push({id:'int'+String(n), type:'int', x: xVal+n, y:yVal+n})
	    n++;
	}
    }

    function addObjectAnchors() {
	$(".network-obj").each(function(i, el) {
	    id = 0;
	    nodes.push({id: 'object'+String(i)+'corner'+String(id), x: $(this).offset().left, y: $(this).offset().top - 50, type: 'anchor'})
	    id++
	    nodes.push({id: 'object'+String(i)+'corner'+String(id), x: $(this).offset().left, y: $(this).offset().top + $(this).height() - 50, type: 'anchor'})
	    id++
	    nodes.push({id: 'object'+String(i)+'corner'+String(id), x: $(this).offset().left + $(this).width(), y: $(this).offset().top - 50, type: 'anchor'})
	    id++
	    nodes.push({id: 'object'+String(i)+'corner'+String(id), x: $(this).offset().left + $(this).width(), y: $(this).offset().top + $(this).height() - 50, type: 'anchor'})
	    id++
	});
    }
    
    i = 0;
    li = 0;
    
    function linkAnchors(a1, a2) {
//	nodes.push({id:'int'+String(i), type:'int'})
	links.push({id:li, source:nodes.filter(function(d) { return d.id == a1;})[0], target:nodes.filter(function(d) { return d.id == 'int'+String(i);})[0]})
	li++;
	i++;
//	nodes.push({id:'int'+String(i), type:'int'})	
	links.push({id:li, source:nodes.filter(function(d) { return d.id == 'int'+String(i-1);})[0], target:nodes.filter(function(d) { return d.id == 'int'+String(i);})[0]})
	li++;	
	links.push({id:li, source:nodes.filter(function(d) { return d.id == 'int'+String(i);})[0], target: nodes.filter(function(d) { return d.id == a2;})[0]})
	li++;
	i++;
    }

    function addConnectors() {
	c = 0;
	interimNodes = nodes.filter(function(d) { return d.type == 'int'; })

	while(c<100) {
	    src = Math.floor((Math.random()*(interimNodes.length-1)))
	    step = Math.floor((Math.random()*5)+1)
	    trgt = src > 6 ? src - step : src + step;
	    if(src!=trgt) {
		links.push({id:li, source:nodes.filter(function(d) { return d.id == interimNodes[src].id;})[0], target:nodes.filter(function(d) { return d.id == interimNodes[trgt].id;})[0]});
	    }
	    c++;
	}
    }

    function linkNodes() {
	linkAnchors('main-corner1', 'object0corner0')
	linkAnchors('main-corner1', 'object0corner1')
	linkAnchors('main-corner1', 'object0corner2')
	linkAnchors('main-corner2', 'object0corner0')
	linkAnchors('main-corner2', 'object0corner1')
	linkAnchors('main-corner2', 'object0corner3')

	linkAnchors('main-corner3', 'object2corner0')
	linkAnchors('main-corner3', 'object2corner2')
	linkAnchors('main-corner3', 'object2corner3')
	linkAnchors('main-corner4', 'object2corner1')
	linkAnchors('main-corner4', 'object2corner2')
	linkAnchors('main-corner4', 'object2corner3')

	linkAnchors('object0corner3', 'object1corner0')
	linkAnchors('object0corner2', 'object1corner1')
	
	linkAnchors('object1corner3', 'object2corner0')
	linkAnchors('object1corner2', 'object2corner1')	
	
	linkAnchors('mid-corner2-top', 'object0corner0')
	linkAnchors('mid-corner2-top', 'object0corner2')
	
	linkAnchors('mid-corner1-top', 'object1corner0')
	linkAnchors('mid-corner1-top', 'object1corner2')
	linkAnchors('mid-corner1-top', 'object0corner0')
	
	linkAnchors('mid-corner3-top', 'object1corner0')
	linkAnchors('mid-corner3-top', 'object1corner2')
	linkAnchors('mid-corner3-top', 'object2corner2')

	linkAnchors('mid-corner2-top', 'object2corner0')
	linkAnchors('mid-corner2-top', 'object2corner2')

	linkAnchors('mid-corner2-btm', 'object0corner1')
	linkAnchors('mid-corner2-btm', 'object0corner3')

	linkAnchors('mid-corner1-btm', 'object1corner1')
	linkAnchors('mid-corner1-btm', 'object1corner3')
	linkAnchors('mid-corner1-btm', 'object0corner1')


	linkAnchors('mid-corner3-btm', 'object1corner1')
	linkAnchors('mid-corner3-btm', 'object1corner3')
	linkAnchors('mid-corner3-btm', 'object2corner3')	

	linkAnchors('mid-corner2-btm', 'object2corner1')
	linkAnchors('mid-corner2-btm', 'object2corner3')
    }

    function stop() {
//	simulation.stop()
    }
    
    
})();
